import React from 'react';
import styles from './FileUpload.module.scss';
import { Box, Text, Stack } from '@chaser/components';

import processingIcon from '../../assets/processing.svg';

const JOBS = {
  uploading: 'Uploading, please wait...',
  processing: 'Processing upload, please wait...',
};

const FileUploadInfoWorking = ({ job = 'uploading' }) => {
  return (
    <Stack gap="small" color="Mid Neutral 1" alignItems="center">
      <Box color="Green AA">
        <svg width="30" height="30" className={styles.spinner}>
          <use href={`${processingIcon}#icon`} x="0" y="0" fill="currentColor" />
        </svg>
      </Box>
      <Text fontWeight="bold">{JOBS[job]}</Text>
    </Stack>
  );
};

export default FileUploadInfoWorking;
